import type { auth as Fr } from '../fr/auth';

/** « auth » in English — typed on the French: a missing sentence does not compile. */
export const auth: typeof Fr = {
};
